import React, { useState, useEffect } from 'react';
// import ReactDOM from 'react-dom';
// import { connect } from 'react-redux';
import ChargeCalculatorPartApp from './ChargeCalculatorPartApp';
import Tools from '../../tools';
import { Button, Container, Modal, Row, Col, Form, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import API from '../../api';
import { Cookies, withCookies } from 'react-cookie';
import Enums from '../../enums'

// import { useMappedState, useDispatch } from 'redux-react-hook';

export default withCookies(function ChargeCalculatorApp(props) {
    const [calResult, setCalResult] = useState(null);

    function onSubmit(data) {
        API.PaymentEstimate(data).
            then((data) => {
                if (data) {
                    if (null != data.price && null != data.platform_point) {
                        setCalResult(`${data.platform_point}點 約台幣${data.price}元`)
                    } else if (data.msg) {
                        alert(data.msg);
                    }
                    else console.log(data);
                } else {
                    alert("Server error");
                    console.log(data);
                }
            });
    }

    function onSaveAndBack(data) {
        API.PaymentEstimate(data).
            then((data) => {
                if (data) {
                    if (null != data.price && null != data.platform_point) {
                        props.history.push("/projs/index");
                    } else if (data.msg) {
                        alert(data.msg);
                    }
                    else console.log(data);
                } else {
                    alert("Server error");
                    console.log(data);
                }
            });
    }

    function onDeposit() {
        props.history.push("/charge/index");
    }

    function render() {
        return (
            <div className="container-fluid pb-4">
                <h2>金額試算</h2>
                <ChargeCalculatorPartApp onDeposit={onDeposit} isShowQCunts={true}
                    isEstimate={true} onSubmit={onSubmit} result={calResult}
                    onSaveAndBack={onSaveAndBack} />
            </div>
        );
    }
    return render();
})